<div class="storage-usage">

    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
        <h6 class="m-0 d-flex align-items-center gap-2 fw-semibold">
            <fa-duotone-icon icon="database" secondaryOpacity="0.4" class="text-primary" />
            {{ DocumentsMessagingConstants.DOCUMENTS_STORAGE_TITLE() }}
        </h6>

        @if (!isLoading() && usage()) {
        <div class="d-flex align-items-center justify-content-end flex-wrap gap-3 text-end">
            @if (isLowOnStorage()) {
            <span class="text-danger fw-semibold d-flex align-items-center gap-2">
                <fa-duotone-icon icon="triangle-exclamation" class="flex-shrink-0" secondaryOpacity="0.4" />
                {{ lowStorageMessage() }}
            </span>
            }

            <span>{{ summaryLabel() }}</span>
        </div>
        }
    </div>

    @if (isLoading()) {
    <div class="progress storage-bar placeholder-glow" aria-hidden="true">
        <span class="placeholder col-12"></span>
    </div>
    } @else if (usage()) {

    <div class="progress storage-bar" role="img" [attr.aria-label]="ariaLabel()">
        @for (segment of segments(); track segment.key) {
        @if (segment.widthPercent > 0) {
        <div [class]="'progress-bar ' + segment.barClass" [style.width.%]="segment.widthPercent"></div>
        }
        }
    </div>

    <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-3">
        <div class="d-flex flex-wrap gap-3 gap-md-4">
            @for (segment of segments(); track segment.key) {
            <div class="d-flex align-items-center gap-2">
                <span [class]="'storage-legend-swatch ' + segment.swatchClass"></span>
                <span>
                    <span class="fw-semibold">{{ segment.label }}</span>
                    <span class="ms-1">{{ segment.valueLabel }}</span>
                </span>
            </div>
            }
        </div>

        <button type="button" class="btn btn-danger empty-trash-button ms-auto d-flex align-items-center gap-2"
            [disabled]="!hasTrash()" (click)="clearTrashRequested.emit()">
            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" />
            {{ DocumentsMessagingConstants.DOCUMENTS_EMPTY_TRASH_BUTTON() }}
        </button>
    </div>

    }
</div>
